import { useEffect } from 'react';
import { colors } from '../../theme';
import styled from 'styled-components';
import { CircularProgress, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authenticationService } from '../../services/authenticationService.service';

const Login = (props) => {
    const navigate = useNavigate();
    const [urlParams] = useSearchParams();

    const token = urlParams.get("token");

    useEffect(() => {
        if (token) {
            authenticationService
                .login(token)
                .then((user) => {
                    navigate('/');
                })
                .catch((error) => navigate('/forbidden'));
        } else {
            navigate('/not-found');
        }
    }, [token]);

    return (
        <PageContainer>
            <CircularProgress size={150} />
            <Typography variant="h2"> Logging you into BCIT Timetable Portal...</Typography>
        </PageContainer>
    );
};

export default Login;

const PageContainer = styled.div`
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${colors.bg};

    h2 {
        font-size: 40px;
        margin-top: 1em;
    }
`;